import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './usuarioForm';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaPerfil,
	getListaNegociador,
	getListaOperacoes,
	getListaFronteira,
	salvarPermissao,
	alterarSenha,
	getListaMenu
} from './usuarioActions';

class Usuario extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		ordenacao: {
			nome: 1
		}
	}

	componentWillMount() {
		this.props.setModoTela('lista');
		this.props.getLista();
		this.props.getListaPerfil();
		this.props.getListaNegociador();
		this.props.getListaOperacoes();
		this.props.getListaFronteira();
		this.props.getListaMenu();
	}

	render() {
		return (
			<div>
				<Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form
							acessoCliente
							onSubmit={this.props.salvar}
						/>
					) : null}

					{this.props.modoTela == 'alterarSenha' ? (
						<Form
							acessoCliente
							alterarSenha
							onSubmit={this.props.alterarSenha}
						/>
					) : null}

					{this.props.modoTela == 'exclusao' ? (
						<Form
							acessoCliente
							excluir
							onSubmit={this.props.excluir}
						/>
					) : null}

					{this.props.modoTela == 'lista' ? this.lista() : null}

				</Content>
			</div>
		)
	}

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i className='fas fa-sort-amount-down-alt' />;
		} else if (tipo == 2) {
			return <i className='fas fa-sort-amount-up' />;
		} else {
			return null;
		}
	}

	getNegociadores(item) {

		return (item.id_negociadores || []).map(id => {

			const negociador = (this.props.listaNegociador || []).filter(
				itemAux => itemAux.id == id
			)[0];

			return negociador ? negociador.valor : '';

		}).filter(item => item).join(', ');
	}

	getOperacoes(item) {

		return (item.id_operacoes || []).map(id => {

			const operacao = (this.props.listaOperacoes || []).filter(
				itemAux => itemAux.id == id
			)[0];

			return operacao ? operacao.valor : '';

		}).filter(item => item).join(', ');
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = (this.props.lista || [])
			.filter(item => item.acesso_cliente)
			.filter(item => {

				return !(this.state.pesquisar || '').trim()
					|| (this.state.pesquisar.toUpperCase() || '')
						.split('+')
						.filter(pesquisar => (pesquisar || '').trim())
						.filter(pesquisar => {

							if (
								pesquisar
								&& !(
									`
										${item.nome || ''}
										${item.login || ''}
									`
								)
									.toUpperCase()
									.includes(pesquisar)
							) {
								return false;
							}

							return true;

						}).length > 0;

			});

		if (this.state.ordenacao.nome) {

			lista.sort((a, b) =>
				this.state.ordenacao.nome == 1
					? ((a.nome || '') > (b.nome || '') ? 1 : -1)
					: ((a.nome || '') > (b.nome || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.login) {

			lista.sort((a, b) =>
				this.state.ordenacao.login == 1
					? ((a.login || '') > (b.login || '') ? 1 : -1)
					: ((a.login || '') > (b.login || '') ? -1 : 1)
			);

		} else if (this.state.ordenacao.negociadores) {

			lista.sort((a, b) => {

				const valorA = this.getNegociadores(a);
				const valorB = this.getNegociadores(b);

				return this.state.ordenacao.negociadores == 1
					? (valorA > valorB ? 1 : -1)
					: (valorA > valorB ? -1 : 1);
			});

		} else if (this.state.ordenacao.operacoes) {

			lista.sort((a, b) => {

				const valorA = this.getOperacoes(a);
				const valorB = this.getOperacoes(b);

				return this.state.ordenacao.operacoes == 1
					? (valorA > valorB ? 1 : -1)
					: (valorA > valorB ? -1 : 1);
			});
		}

		return (
			<ContentCard>

				<ContentCardBody>

					<Row>

						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.state.pesquisar}
							onChange={value =>
								this.setState({
									...this.state,
									pesquisar: value
								})
							}
						/>

						<div
							style={{
								width: 310,
								marginTop: 8,
								marginLeft: 8
							}}
						>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {
									this.props.getLista();
								}}
							>
								<i className='fas fa-sync-alt'></i>
								{' '}Atualizar
							</a>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {

									const registro = {
										acesso_cliente: true,
										primeiro_acesso: true,
										id_perfil: 32
									};

									this.props.setModoTela(
										'cadastro',
										registro
									);

									this.props.initForm(registro);
								}}
							>
								<i className='fas fa-plus'></i>
								{' '}Adicionar
							</a>

							<ExcelFile
								filename={'Usuários Clientes'}
								element={
									<a
										className='btn btn-app bg-success'
										style={{
											marginLeft: 2,
											minWidth: 75
										}}
									>
										<i className='fas fa-file-excel'></i>
										{' '}Exportar
									</a>
								}
							>
								<ExcelSheet
									data={lista.map(item => ({
										...item,
										negociadores: this.getNegociadores(item),
										operacoes: this.getOperacoes(item),
										reports_exportar: item.reports ? 'Sim' : 'Não',
										track_exportar: item.track ? 'Sim' : 'Não',
										app_cliente_exportar: item.app_cliente ? 'Sim' : 'Não',
										nacional_exportar: item.nacional ? 'Sim' : 'Não',
										internacional_exportar: item.internacional ? 'Sim' : 'Não',
										rumo_norte_exportar: item.rumo_norte ? 'Sim' : 'Não',
										rumo_sul_exportar: item.rumo_sul ? 'Sim' : 'Não',
										track_indicadores_exportar: item.track_indicadores ? 'Sim' : 'Não'
									}))}
									name='Usuários Clientes'
								>
									<ExcelColumn
										label='Nome'
										value='nome'
									/>

									<ExcelColumn
										label='Login'
										value='login'
									/>

									<ExcelColumn
										label='Negociadores'
										value='negociadores'
									/>

									<ExcelColumn
										label='Operações Logísticas'
										value='operacoes'
									/>

									<ExcelColumn
										label='Reports'
										value='reports_exportar'
									/>

									<ExcelColumn
										label='Track'
										value='track_exportar'
									/>

									<ExcelColumn
										label='App Cliente'
										value='app_cliente_exportar'
									/>

									<ExcelColumn
										label='Nacional'
										value='nacional_exportar'
									/>

									<ExcelColumn
										label='Internacional'
										value='internacional_exportar'
									/>

									<ExcelColumn
										label='Rumo Norte'
										value='rumo_norte_exportar'
									/>

									<ExcelColumn
										label='Rumo Sul'
										value='rumo_sul_exportar'
									/>

									<ExcelColumn
										label='Indicadores Track'
										value='track_indicadores_exportar'
									/>
								</ExcelSheet>
							</ExcelFile>

						</div>

					</Row>

					<div
						style={{
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768
								? '100%'
								: (
									window.innerWidth < 1093
										? `${window.innerHeight - 300}px`
										: (
											window.innerWidth < 1799
												? `${window.innerHeight - 180}px`
												: (
													window.innerWidth < 4000
														? `${window.innerHeight - 180}px`
														: `${window.innerHeight - 110}px`
												)
										)
								)
						}}
					>

						<Table
							responsive
							border
							striped
							alturaFixa
							maxHeight={
								window.innerWidth < 768
									? '100%'
									: (
										window.innerWidth < 1093
											? `${window.innerHeight - 300}px`
											: (
												window.innerWidth < 1799
													? `${window.innerHeight - 180}px`
													: (
														window.innerWidth < 4000
															? `${window.innerHeight - 180}px`
															: `${window.innerHeight - 110}px`
													)
											)
									)
							}
						>

							<THead>

								<Tr
									backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}
								>

									<Th
										minWidth={180}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													nome: this.getNovaOrdenacao(
														this.state.ordenacao.nome
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignLeft
									>
										Nome {this.getIconeOrdenacao(
											this.state.ordenacao.nome
										)}
									</Th>

									<Th
										minWidth={150}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													login: this.getNovaOrdenacao(
														this.state.ordenacao.login
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Login {this.getIconeOrdenacao(
											this.state.ordenacao.login
										)}
									</Th>

									{/*<Th
										minWidth={300}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													negociadores: this.getNovaOrdenacao(
														this.state.ordenacao.negociadores
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Negociadores {this.getIconeOrdenacao(
											this.state.ordenacao.negociadores
										)}
									</Th>

									<Th
										minWidth={300}
										paddingTop={2}
										paddingBottom={2}
										onClick={() =>
											this.setState({
												...this.state,
												ordenacao: {
													operacoes: this.getNovaOrdenacao(
														this.state.ordenacao.operacoes
													)
												}
											})
										}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Operações Logísticas {this.getIconeOrdenacao(
											this.state.ordenacao.operacoes
										)}
									</Th>*/}

									<Th
										minWidth={70}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Reports
									</Th>

									<Th
										minWidth={60}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Track
									</Th>

									<Th
										minWidth={90}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										App Cliente
									</Th>

									<Th
										minWidth={80}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Nac
									</Th>

									<Th
										minWidth={100}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										Int
									</Th>

									<Th
										minWidth={90}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										RN
									</Th>

									<Th
										minWidth={90}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
										RS
									</Th>

									<Th
										minWidth={90}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
										title='Indicadores no Track'
									>
										Ind. Track
									</Th>

									<Th
										minWidth={150}
										width={150}
										paddingTop={2}
										paddingBottom={2}
										sticky
										backgroundColor={'#1F3066'}
										color={'#ffffff'}
										alignCenter
									>
									</Th>

								</Tr>

							</THead>

							<TBody>

								{lista.map((item, i) => (

									<Tr
										key={item.id}
										backgroundColor={
											this.state.linhaSelecionada == item.id
												? '#bcc7eb'
												: (
													i % 2 == 0
														? '#ffffff'
														: '#f5f5f5'
												)
										}
										onClick={() =>
											this.setState({
												...this.state,
												linhaSelecionada: item.id
											})
										}
									>

										<Td
											color={'#000'}
											alignLeft
											small
										>
											{item.nome}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
										>
											{item.login}
										</Td>

										{/*<Td
											color={'#000'}
											alignCenter
											small
											noWrap
										>
											{this.getNegociadores(item)}
										</Td>

										<Td
											color={'#000'}
											alignCenter
											small
											noWrap
										>
											{this.getOperacoes(item)}
										</Td>*/}

										<Td alignCenter>
											<input
												type='checkbox'
												checked={item.reports || false}
												onChange={() =>
													this.props.salvarPermissao({
														...item,
														reports: !item.reports
													})
												}
											/>
										</Td>

										<Td alignCenter>
											<input
												type='checkbox'
												checked={item.track || false}
												onChange={() =>
													this.props.salvarPermissao({
														...item,
														track: !item.track
													})
												}
											/>
										</Td>

										<Td
											alignCenter
											minWidth={50}
										>
											<input
												type='checkbox'
												checked={item.app_cliente || false}
												onChange={() =>
													this.props.salvarPermissao({
														...item,
														app_cliente: !item.app_cliente
													})
												}
											/>
										</Td>

										<Td alignCenter>
											<input
												type='checkbox'
												checked={item.nacional || false}
												onChange={() =>
													this.props.salvarPermissao({
														...item,
														nacional: !item.nacional
													})
												}
											/>
										</Td>

										<Td alignCenter>
											<input
												type='checkbox'
												checked={item.internacional || false}
												onChange={() =>
													this.props.salvarPermissao({
														...item,
														internacional: !item.internacional
													})
												}
											/>
										</Td>

										<Td alignCenter>
											<input
												type='checkbox'
												checked={item.rumo_norte || false}
												onChange={() =>
													this.props.salvarPermissao({
														...item,
														rumo_norte: !item.rumo_norte
													})
												}
											/>
										</Td>

										<Td alignCenter>
											<input
												type='checkbox'
												checked={item.rumo_sul || false}
												onChange={() =>
													this.props.salvarPermissao({
														...item,
														rumo_sul: !item.rumo_sul
													})
												}
											/>
										</Td>

										<Td alignCenter>
											<input
												type='checkbox'
												checked={item.track_indicadores || false}
												onChange={() =>
													this.props.salvarPermissao({
														...item,
														track_indicadores: !item.track_indicadores
													})
												}
											/>
										</Td>

										<Td
											minWidth={150}
											width={150}
											alignCenter
										>

											<ButtonTable
												type={'primary'}
												icon={'fas fa-copy'}
												visible={true}
												small
												title='Duplicar'
												event={() => {

													const registro = {
														...item,
														primeiro_acesso: true,
														duplicado: true,
														nome: null,
														login: null,
														email: null,
														senha: null
													};

													this.props.setModoTela(
														'cadastro',
														{
															...registro,
															id: null
														}
													);

													this.props.initForm({
														...registro,
														id: null
													});
												}}
											/>

											<ButtonTable
												type={'warning'}
												icon={'fas fa-user-lock'}
												visible={true}
												small
												title='Alterar senha'
												event={() => {

													const registro = {
														...item,
														primeiro_acesso: true,
														senha: null
													};

													this.props.setModoTela(
														'alterarSenha',
														registro
													);

													this.props.initForm(
														registro
													);
												}}
											/>

											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												small
												event={() => {

													this.props.setModoTela(
														'cadastro',
														{
															...item
														}
													);

													this.props.initForm({
														...item
													});
												}}
											/>

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={true}
												small
												event={() => {

													const registro = {
														...item,
														senha: null
													};

													this.props.setModoTela(
														'exclusao',
														registro
													);

													this.props.initForm(
														registro
													);
												}}
											/>

										</Td>

									</Tr>

								))}

							</TBody>

						</Table>

					</div>

				</ContentCardBody>

			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.usuario.aguardando,
	modoTela: state.usuario.modoTela,
	lista: state.usuario.lista,
	listaNegociador: state.usuario.listaNegociador,
	listaOperacoes: state.usuario.listaOperacoes
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaPerfil,
	getListaNegociador,
	getListaOperacoes,
	getListaFronteira,
	salvarPermissao,
	alterarSenha,
	getListaMenu
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Usuario);